import { ApiError } from '@clockwise/shared';

/**
 * When a timesheet save can't resolve the member's customer-team role (the
 * activity is loggable under more than one of the user's roles on the
 * customer), the server returns a 422 with a `ROLE_REQUIRED` field error whose
 * `constraint.candidateRoleIds` carries the candidate role ids. Returns that id
 * list when the error is ROLE_REQUIRED, else null — the caller then opens the
 * role disambiguation dialog and retries the save with the chosen
 * `customerTeamServiceRoleId`.
 */
export function roleRequiredCandidates(err: unknown): string[] | null {
  if (!(err instanceof ApiError)) return null;
  const field = err.fields?.find((f) => f.code === 'ROLE_REQUIRED');
  if (!field) return null;
  const candidates = (field.constraint as { candidateRoleIds?: unknown } | undefined)
    ?.candidateRoleIds;
  if (Array.isArray(candidates))
    return candidates.filter((id): id is string => typeof id === 'string');
  // Defensive fallback for the legacy CSV-in-`value` shape.
  return field.value == null ? [] : String(field.value).split(',').filter(Boolean);
}
